/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ChannelProps } from '@/types/tv/channels/Channel'

class Channel {
    cat: string[]
    drm: number
    drmId: string
    icon: string
    id: string
    lcn: string
    licenseProxyUri: string
    name: string
    origin: number
    preAuthTokenUri: string
    service: number
    uri: string
    list: string[]
    drmType: string | null
    skipIntroDetails?: {
        skipIntroShowMillis?: number
        skipIntroHideMillis?: number
        skipIntroSeekToMillis?: number
    }
    nextVideoDetails?: {
        title?: string
        productId?: string
        productType?: string
        thumbnailUri?: string
        showBeforeEndMillis?: number
        autoSwitchToNextMillis?: number
    }
    certificateUri?: string | null

    constructor(channelProps: ChannelProps) {
        this.cat = channelProps.cat
        this.drm = channelProps.drm
        this.drmId = channelProps.drmId
        this.icon = channelProps.icon
        this.id = channelProps.id?.toString()
        this.lcn = channelProps.lcn
        this.licenseProxyUri = channelProps.licenseProxyUri
        this.name = channelProps.name
        this.origin = channelProps.origin
        this.preAuthTokenUri = channelProps.preAuthTokenUri
        this.service = channelProps.service
        this.uri = channelProps.uri
        this.list = channelProps.list
        this.drmType = this.getDrmType()
        this.certificateUri = channelProps.certificateUri
    }

    // Method to serialize channel instance into plain object
    static serialize(channel: Channel) {
        return {
            cat: channel.cat,
            drm: channel.drm,
            drmId: channel.drmId,
            icon: channel.icon,
            id: channel.id,
            lcn: channel.lcn,
            licenseProxyUri: channel.licenseProxyUri,
            name: channel.name,
            origin: channel.origin,
            preAuthTokenUri: channel.preAuthTokenUri,
            service: channel.service,
            uri: channel.uri,
            list: channel.list,
            drmType: channel.drmType,
            skipIntroDetails: channel.skipIntroDetails,
            nextVideoDetails: channel.nextVideoDetails,
            certificateUri: channel.certificateUri,
        }
    }

    // Method to deserialize plain object into a Channel instance
    static deserialize(data: any): Channel {
        return new Channel(data)
    }

    checkOrigin = (): string => {
        switch (this.origin) {
            case 0:
                return 'DVB'
            case 1:
                return 'IPTV'
            case 2:
                return 'OTT'

            default:
                return ''
        }
    }

    getDrmType = (): 'noDrm' | 'widevine' | 'cas' | 'drmFairPlay' | null => {
        switch (this.drm) {
            case 0:
                return 'noDrm'
            case 1:
                return 'widevine'
            case 2:
                return 'cas'
            case 3:
                return 'drmFairPlay'
            default:
                return null
        }
    }
    async initializeUri(channelData: Channel) {
        this.uri = channelData.uri
    }
}

export default Channel
